import React from 'react';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import { green } from '@mui/material/colors';
import { red } from '@mui/material/colors';
import { Button } from '@mui/material';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    cursorLink: {
        cursor: 'pointer'
    }
});


export default function DisciplinaTurmaTable({ tdps, setTdp }) {
    const classes = useStyles();

    return (
        <Table className={classes.table} size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell>Descrição</TableCell>
                    <TableCell>Capacidade Máxima</TableCell>
                    <TableCell>É Eletiva</TableCell>
                    <TableCell>É Projeto</TableCell>
                    <TableCell>Escolha Aluno</TableCell>
                    <TableCell>Carga Horária</TableCell>
                    <TableCell>Selecionar</TableCell>

                </TableRow>
            </TableHead>
            <TableBody>
                {tdps && tdps.map((tdp) => (
                    <TableRow key={tdp.disciplina.codDisciplina}>
                        <TableCell>{tdp.disciplina.descricao}</TableCell>
                        <TableCell>{tdp.capacidadeMaxima ? tdp.capacidadeMaxima : '--'}</TableCell>
                        <TableCell>
                            {tdp.eEletiva ?
                                <CheckCircle style={{ color: green[500] }} /> :
                                <Cancel style={{ color: red[500] }} />}
                        </TableCell>
                        <TableCell>
                            {tdp.eProjeto ?
                                <CheckCircle style={{ color: green[500] }} /> :
                                <Cancel style={{ color: red[500] }} />}
                        </TableCell>
                        <TableCell>
                            {tdp.escolhaAluno ?
                                <CheckCircle style={{ color: green[500] }} /> :
                                <Cancel style={{ color: red[500] }} />}
                        </TableCell>
                        <TableCell>{tdp.cargaHoraria ? tdp.cargaHoraria : '--'}</TableCell>
                        <TableCell>
                            <Button
                                variant='outlined'
                                onClick={() => setTdp(tdp)}
                            >
                                Selecionar
                            </Button>
                        </TableCell>

                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}